import { Trans, useTranslation } from 'react-i18next';
import classnames from 'classnames';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { BackButton } from '@/components/BackButton';
import { OtpCodeInput } from '@/components/OtpCodeInput';
import { useCountdown } from '@/hooks/useCountdown';
import { useResendChangeEmail } from '@/query/queries/user/useResendChangeEmail';
import { useVerifyChangeEmail } from '@/query/queries/user/useVerifyChangeEmail';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

const VALIDATION_SCHEMA = Yup.object({
  code: Yup.array(),
});

export const ConfirmEmailStep = ({ email, onBack, onNext }) => {
  const { t } = useTranslation('modal');
  const { mutateAsync: resendChangeEmail } = useResendChangeEmail();
  const { mutateAsync: verifyChangeEmail } = useVerifyChangeEmail();
  const { timeLeft, restart: restartCountdown } = useCountdown();

  const onSubmit = async ({ code }, formik) => {
    const { success, error } = await verifyChangeEmail({ code: code.join('') });
    formik.setSubmitting(false);

    if (success) {
      onNext();
      return;
    }
    formik.setErrors({ code: error });
  };
  const onResendCode = async () => {
    const { success, error } = await resendChangeEmail();
    if (success) {
      restartCountdown();
      return;
    }
    formik.setErrors({ code: error });
  };

  const { values, errors, touched, setFieldValue, isSubmitting, handleSubmit } = useFormik({
    onSubmit,
    validationSchema: VALIDATION_SCHEMA,
    initialValues: {
      code: [],
    },
  });

  return (
    <div className={s.modal}>
      <h1 className="f-hero-h5">
        {t('change_email_modal.email_verification')}
      </h1>
      <div className={s.content}>
        <div>
          <Trans
            ns="modal"
            i18nKey="change_email_modal.email_verification_instruction"
            values={{ email }}
            components={{
              span: <span className="f-500" />,
            }}
          />
        </div>
        <form className={s.form} onSubmit={handleSubmit}>
          <div className={s.otp_wrapper}>
            <OtpCodeInput
              values={values.code}
              className={s.otp}
              error={errors.code && touched.code}
              onChange={value => setFieldValue('code', value.split(''))}
              onComplete={() => {
                handleSubmit();
              }}
              showDash={false}
              disabled={isSubmitting}
            />
            {touched.code && errors.code && (
              <div className={s.error}>{errors.code}</div>
            )}
          </div>
          <div className={s.footer}>
            <BackButton onClick={onBack} />
            <button
              type="button"
              className={classnames(s.button, r.black_large)}
              style={{ minWidth: 170 }}
              onClick={onResendCode}
              disabled={
                timeLeft > 0
                || isSubmitting
              }
            >
              {t('change_email_modal.resend_code')}
              {timeLeft === 0 ? '' : `: ${timeLeft}`}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
